import axios from "axios"
import { useEffect, useState } from "react"
import { STRAPI_API } from "../const/Endpoints"
import { STRAPI_API_KEY } from "../const/Keys"
import { alenaxios } from "../functions/alenaxios"

export function useApi(endpointUri, noStrapi, ttl) {
    const [Data, setData] = useState(null)
    const [Error, setError] = useState(null)
    const [Loading, setLoading] = useState(false)


    useEffect(() => {
        (
            async function () {
                if (!endpointUri) return null
                let endpoint = (noStrapi ? "" : STRAPI_API) + endpointUri
                setError(false)
                setLoading(true)

                let config = {
                    method: 'get',
                    url: endpoint,
                    headers: {
                        'Authorization': `Bearer ${STRAPI_API_KEY}`
                    },
                    ttl: ttl,
                };


                let fetcher = ttl == 0 ? axios : alenaxios

                fetcher(config)
                    .then(res => { setData(res.data || {}) })
                    .catch(() => { setError(true); console.log("err") })
                    .finally(() => setLoading(false))
            }
        )()
    }, [])

    return { Data, Loading, Error }
}

